import { PayloadAction, SliceCaseReducers, ValidateSliceCaseReducers } from '@reduxjs/toolkit';

import { SliceState } from './slice-state';

export const reducers: ValidateSliceCaseReducers<SliceState, SliceCaseReducers<SliceState>> = {
    /**
     * Sample reducer
     */
    setSomething: (state, action: PayloadAction<string>) => {
        state.sliceStateParam = action.payload;
    },
};
